import {typesJetFly} from './svtypes/flyTypes'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
let initStore = {
    loading: false,
    error: false,
    xxob:{
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "org": "09A",
        "dst": "ADQ"
    },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    svfly_esquery_data : {
        airlines:[
            {
                "name" : "Allegiant Air",
                "IATA" : "G4"
            },
            {
                "name" : "Air Italy",
                "IATA" : "I9"
            },
            {
                "name" : "America West Airlines",
                "IATA" : "HP"
            },
            {
                "name" : "Alaska Airlines",
                "IATA" : "AS"
            },
            {
                "name" : "Atlantic Southeast Airlines",
                "IATA" : "EV"
            },
            {
                "name" : "American Eagle Airlines",
                "IATA" : "MQ"
            },
            {
                "name" : "Delta Air Lines",
                "IATA" : "DL"
            },
            {
                "name" : "Frontier Airlines",
                "IATA" : "F9"
            },
            {
                "name" : "Hawaiian Pacific Airlines",
                "IATA" : "HP"
            },
            {
                "name" : "Indigo",
                "IATA" : "I9"
            },
            {
                "name" : "Jet Airways",
                "IATA" : "QJ"
            },
            {
                "name" : "JetBlue Airways",
                "IATA" : "B6"
            },
            {
                "name" : "Midway Airlines",
                "IATA" : "JI"
            },
            {
                "name" : "Northwest Airlines",
                "IATA" : "NW"
            },
            {
                "name" : "Pearl Airways",
                "IATA" : "HP"
            },
            {
                "name" : "Phoenix Airways",
                "IATA" : "HP"
            },
            {
                "name" : "Sun Country Airlines",
                "IATA" : "SY"
            },
            {
                "name" : "Southwest Airlines",
                "IATA" : "WN"
            },
            {
                "name" : "Spirit Airlines",
                "IATA" : "NK"
            },
            {
                "name" : "Trans World Airlines",
                "IATA" : "TW"
            },
            {
                "name" : "United Airlines",
                "IATA" : "UA"
            },
            {
                "name" : "US Airways",
                "IATA" : "US"
            },
            {
                "name" : "Virgin America",
                "IATA" : "VX"
            },
            {
                "name" : "Caucasus Airlines",
                "IATA" : "NS"
            },
            {
                "name" : "Tway Airlines",
                "IATA" : "TW"
            }
        ]
        
        
        ,
        amap:{
            "B6":{
                "name" : "JetBlue Airways",
                "IATA" : "B6"
            },
            "UA":{
                "name" : "United Airlines",
                "IATA" : "UA"
            }
        },
        pmap:{
            "DCA":{
                "airportid": 3520,
                "altitude": 15,
                "city": "Washington",
                "country": "United States",
                "datsource": "OurAirports",
                "name": "Ronald Reagan Washington National Airport",
                "stationType": null,
                "svdst": "A",
                "svtimezone": "-5",
                "svtzDatabaseTimezone": "America/New_York",
                "IATA": "DCA",
                "ICAO": "KDCA",
                "LAT": 38.8521,
                "LNG": -77.037697
            }
        },
        esqueryDestMob :{
            "type": "location",
            "subType": "AIRPORT",
            "name": "JOHN F KENNEDY INTL",
            "detailedName": "NEW YORK/NY/US:JOHN F KENNEDY",
            "id": "AJFK",
            
            "timeZoneOffset": "-04:00",
            "iataCode": "JFK",
            "geoCode": {
              "latitude": 40.63973,
              "longitude": -73.77861
            },
            "address": {
              "cityName": "NEW YORK",
              "cityCode": "NYC",
              "countryName": "UNITED STATES OF AMERICA",
              "countryCode": "US",
              "stateCode": "NY",
              "regionCode": "NAMER"
            },
            "analytics": {
              "travelers": {
                "score": 35
              }
            }
          },
           esqueryMob :{
               iataCode: "ORD",
               address:  { cityName: "CHICAGO", cityCode: "CHI", countryName: "UNITED STATES OF AMERICA" },
               detailedName: "CHICAGO/IL/US:O HARE INTERNATI",
               geoCode:  { latitude: 41.97862, longitude: -87.90472 },

            },
        escountryOrg:"US",
        escountryDst:"US",
        my_orgqueryText: "xx",
        my_dstqueryText: "yy",
        STARTDATE:"2025-11-25",
        ENDDATE: "2025-11-27",
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "Asia/Kolkata",


        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esqueryCabin:"ECONOMY",
        esqueryTripType:"roundtrip",
        svpageSize:5


    },

    crudoffer_flag: 'I',

    my_data_svtoffee:{
        "customerId": 7,
        "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
        "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
    },
    //mcicountryDst
    my_data_svmci:{
        "id": "addLeft_step",
        "testlastName": "svlondonKW",
        "gene":"svgene",
       
        "members": [
            {
                "tid": 1,
                
                "my_orgqueryText": "JFK",
                "my_dstqueryText": "LAX",
                "mcicountryOrg":"US",
                "mcicountryDst":"US",
                "STARTDATE":"2024-12-03",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata"
               
            },
            {
                "tid": 2,
                
                "my_orgqueryText": "LAX",
                "my_dstqueryText": "SFO",
                "mcicountryOrg":"US",
                "mcicountryDst":"US",
                "STARTDATE":"2024-12-07",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata"
               
            },
            {
                "tid": 3,
               
                "my_orgqueryText": "SFO",
                "my_dstqueryText": "JFK",
                "mcicountryOrg":"US",
                "mcicountryDst":"US",
                "STARTDATE":"2024-12-17",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata"
               
            }
        ],
           "gender": "MALE"
    },
    
    
    sojourns:[{
        "sojourncode": "200",
        "vernacularcode": "EN",
        "sojourn_name": "200 Mary Resort"
    },
    {
        "sojourncode": "201",
        "vernacularcode": "EN",
        "sojourn_name": "201 John Resort"
    }],
    
    radio_data: [
        
        {
            "name": "3",
            "id": 3,
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "4",
            "id": 4,
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ],
    svr_soj_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    my_data_amb : [{
        "type": "flight-offer",
        "id": "1",
        "source": "GDS",
        "instantTicketingRequired": false,
        "nonHomogeneous": false,
        "oneWay": false,
        "isUpsellOffer": false,
        "lastTicketingDate": "2024-10-24",
        "lastTicketingDateTime": "2024-10-24",
        "numberOfBookableSeats": 1,
        "itineraries": [
            {
                "duration": "PT46H34M",
                "segments": [
                    {
                        "departure": {
                            "iataCode": "EWR",
                            "terminal": "B",
                            "at": "2024-11-01T19:59:00"
                        },
                        "arrival": {
                            "iataCode": "LAX",
                            "terminal": "6",
                            "at": "2024-11-01T23:10:00"
                        },
                        "carrierCode": "AS",
                        "number": "287",
                        "aircraft": {
                            "code": "7M9"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT6H11M",
                        "id": "1",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "LAX",
                            "terminal": "6",
                            "at": "2024-11-02T19:45:00"
                        },
                        "arrival": {
                            "iataCode": "ANC",
                            "terminal": "S",
                            "at": "2024-11-03T00:19:00"
                        },
                        "carrierCode": "AS",
                        "number": "193",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT5H34M",
                        "id": "2",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "ANC",
                            "terminal": "S",
                            "at": "2024-11-03T13:30:00"
                        },
                        "arrival": {
                            "iataCode": "ADQ",
                            "at": "2024-11-03T14:33:00"
                        },
                        "carrierCode": "AS",
                        "number": "89",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT1H3M",
                        "id": "3",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    }
                ]
            }
        ],
        "price": {
            "currency": "USD",
            "total": "1446.23",
            "base": "1324.63",
            "fees": [
                {
                    "amount": "0.00",
                    "type": "SUPPLIER"
                },
                {
                    "amount": "0.00",
                    "type": "TICKETING"
                }
            ],
            "grandTotal": "1446.23"
        },
        "pricingOptions": {
            "fareType": [
                "PUBLISHED"
            ],
            "includedCheckedBagsOnly": true
        },
        "validatingAirlineCodes": [
            "AS"
        ],
        "travelerPricings": [
            {
                "travelerId": "1",
                "fareOption": "STANDARD",
                "travelerType": "ADULT",
                "price": {
                    "currency": "USD",
                    "total": "1446.23",
                    "base": "1324.63"
                },
                "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "2",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "3",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }],
    my_data: [{
        "airport_id" : 298,
        "origin_airport_code" : "lfw",
        "origincity" : "lome",
        "origin_airport_city" : "lome",
        "origin_airport_country" : "togo",
        "origin_airport_timezone" : "africa/lome",
        "port_code_iata" : "2j",
        "airlines_db_id" : 470,
        "origin_airport_iata" : "lfw",
        "dst_airport_code" : "oua",
        "airlines_vessel" : "m87 crj",
        "airlines_name" : "air burkina",
        "airlines_code_iata" : "2j",
        "flight_space_id" : 89,
        "startdate" : "2023-11-24",
        "enddate" : "2026-12-01",
        "flight_space_key" : "lfw@2j@lfw@oua"
      }]
}



export default (state = initStore, action) => {
    console.log(action)
    let januState, svns
    switch (action.type) {
        case "sojourns/LIST_ITINS":

     console.log('tasks LIST_ITINS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case "GET_JET_FLY_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg OCT30 reducer  success*****************");
            console.log(action.payload.my_data);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            if(action.payload.svfly_esquery_data){
                januState = {...state, error: false, loading: false, my_data: action.payload.my_data, my_data_geo: action.payload.my_data_geo, svr_soj_images: action.payload.my_images, svfly_esquery_data:action.payload.svfly_esquery_data}
  
            
            }else{
                januState = {...state,  error: false,loading: false, my_data: action.payload.my_data,my_data_geo: action.payload.my_data_geo, svr_soj_images: action.payload.my_images}
  
            
            }
                       return januState
        case "radio-success":
                console.log("radio success");
                console.log(action.payload.my_data);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                 januState = {...state, loading: false, radio_data: action.payload.radio_data}
                return januState
        case typesJetFly.GET_JET_FLY_BEGIN:
            console.log("loading")
            return {...state, error: false,loading: true}
        case typesJetFly.GET_JET_FLY_ERROR:
            console.log("error")
            return {...state, error: true}
        /*SVNOV17 START */
        case "SVFINDFILTERS_SUCCESS":
                console.log("SV NOV18** SVFINDFILTERS_SUCCESS");
                console.log(action.payload.svfly_esquery_data);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                 januState = {...state, loading: false, svfly_esquery_data: action.payload.svfly_esquery_data}
                return januState
        case 'FLYMYRESERVATIONS_PRIMARY_SVMCI':
            console.log("Nov8 Gort action flyLoadsvmciData reduce Nov3 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_SVMCI  success*****************");
            console.log(action.payload.my_data_svmci);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state,  my_data_svmci: action.payload.my_data_svmci}
            return januState

        case 'FLYMYRESERVATIONS_PRIMARY_SVTFE':
                console.log("Nov8 Gort action FLYMYRESERVATIONS_PRIMARY_SVTFE reduce Nov3 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_SVMCI  success*****************");
                console.log(action.payload.my_data_svtoffee);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  my_data_svtoffee: action.payload.my_data_svtoffee}
                return januState
       
        case 'SAVEMCI_FLYREVIEW_SUCCESS':
                        console.log("reduce %%%%%%%% NOV-11****SAVEMCI_FLYREVIEW_SUCCESS   success*****************");
                        console.log(action.payload.my_data_svmci);
                            // let januState = {...state, loading: false, my_data: action.payload.my_data}
                        januState = {...state,  my_data_svmci: action.payload.my_data_svmci}
                        return januState
        /*SVNOV17 END */

        /*svdec start*/
        case "GET_SAVEUSERSVOFFER_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg GET_SAVEADDRESS_SUCCESS   success*****************");
            console.log(action.payload.my_data_svtoffee);
            // let januState = {...state, loading: false, my_data_addressdet: action.payload.my_data_addressdet}
            /*svj17 start
            januState = {...state, crudoffer_flag:'S', error: true,loading: false, xxob:null,my_data_svtoffee: action.payload.my_data_svtoffee}
            
            */
            januState = {...state, crudoffer_flag:'S', error: false,loading: false, xxob:null,my_data_svtoffee: action.payload.my_data_svtoffee}
             /*svj17 end*/
            return januState
        case "GET_SAVEADDRESS_BEGIN":
                    console.log(" GET_SAVEADDRESS_BEGIN loading")
                    return {...state, crudoffer_flag:'I',loading: true}
        case "GET_SAVEADDRESS_ERROR":
                    console.log("GET_SAVEADDRESS_ERROR error")
                    console.log(action.payload.errob)
               
                return {...state,errob:action.payload.errob,my_data_svtoffee:null, error: true, crudoffer_flag:'E'}
 

        /*svdec2 end*/
        /*svdec3 start*/
        case "GET_SAVEUSERSVOFFER_BEGIN":
            console.log(" GET_SAVEADDRESS_BEGIN loading")
            return {...state, crudoffer_flag:'I',loading: true}
        case "GET_SAVEUSERSVOFFER_ERROR":
            console.log("GET_SAVEADDRESS_ERROR error")
            console.log(action.payload.errob)
       
        return {...state,errob:action.payload.errob,my_data_svtoffee:null, error: true, crudoffer_flag:'E'}

        /*svdec3 end*/
        default:
            return state
    }
}